import { useTranslation } from "react-i18next";
import { Button, Icon, Segment } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";
import { SortableQuestions } from "modules/ChecklistsDashboard/components/EditChecklistModal/components";

import type { Checklist, Question, QuestionGroup } from "models";

type ChecklistQuestionGroupProps = {
  questionGroup: QuestionGroup;
  questionGroupIdx: number;
  isFirst: boolean;
  isLast: boolean;
  canEdit: boolean;
  onMove: (fromIdx: number, toIdx: number) => void;
  onRemove: (questionGroupIdx: number) => void;
  onAddQuestion: (questionGroupIdx: number) => void;
  onChangeQuestions: (questionGroupIdx: number, questions: Question[]) => void;
};

const FormHelper = createFormHelper<Checklist>();

export const ChecklistQuestionGroup = ({
  questionGroup,
  questionGroupIdx,
  isFirst,
  isLast,
  canEdit,
  onMove,
  onRemove,
  onAddQuestion,
  onChangeQuestions
}: ChecklistQuestionGroupProps) => {
  const { t } = useTranslation();

  return (
    <Segment className="question-group">
      <div className="question-group-header">
        <FormHelper.Field.Input
          name={`question_groups.${questionGroupIdx}.name`}
          formFieldProps={{ className: "question-group-name" }}
          inputProps={{ placeholder: t("v8_group_name", "Group name"), fluid: true, disabled: !canEdit }}
        />

        {canEdit && (
          <div className="question-group-actions">
            {!isLast && (
              <Button type="button" className="-appointment-status icon" size="small" onClick={() => onMove(questionGroupIdx, questionGroupIdx + 1)}>
                <Icon className="chevron down" color="black" />
              </Button>
            )}

            {!isFirst && (
              <Button type="button" className="-appointment-status icon" size="small" onClick={() => onMove(questionGroupIdx, questionGroupIdx - 1)}>
                <Icon className="chevron up" color="black" />
              </Button>
            )}

            <Button type="button" className="-appointment-status icon" size="small" onClick={() => onAddQuestion(questionGroupIdx)}>
              <Icon className="plus" />
            </Button>

            {!questionGroup.questions?.length && (
              <Button type="button" className="-appointment-status icon" size="small" onClick={() => onRemove(questionGroupIdx)}>
                <Icon className="trash" color="red" />
              </Button>
            )}
          </div>
        )}
      </div>

      <SortableQuestions questions={questionGroup.questions ?? []} canEdit={canEdit} onChange={questions => onChangeQuestions(questionGroupIdx, questions)} />
    </Segment>
  );
};
